import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ProjectTechstackService } from './project-techstack.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-project-techstack',
  templateUrl: './project-techstack.component.html',
  styleUrls: ['./project-techstack.component.css'],

})
export class ProjectTechstackComponent {
  projects = []
  managers = []
  customers = [];
  allCustomers = [];
  allProjects = [];
  allManagers = [];
  projectData: any;
  showGrid: boolean;
  clintId: number;
  projectId: number;
  managerId: number;
  projectInput = new FormControl();
  projectInputValue = new FormControl();
  managerInputValue = new FormControl();
  showSearchBox: boolean = false;
  isCustomerSelected = false;
  serviceLinesMap;
  intialServiceLinesMap;
  selectCustomer(item) {
    this.isCustomerSelected = true;
  }
  constructor(private http: HttpClient, private service: ProjectTechstackService) {
  }

  ngOnInit(): void {
    this.projectInput.setValue('');
    this.getCustomers();
    this.competencyAndServiceLineGridData();

    this.projectInput.valueChanges.subscribe(value => {
      if (!value) {
        this.projects = [];
        this.managers = [];
        this.projectId = null;
        this.managerId = null;
        this.projectInputValue.setValue('');
        this.managerInputValue.setValue('');
        this.showSearchBox = false;
        this.showGrid = false;
      }
    });
    this.projectInputValue.valueChanges.subscribe(value => {
      if (!value) {
        this.managers = [];
        this.managerId = null;
        this.managerInputValue.setValue('');
        this.showSearchBox = false;
        this.showGrid = false;
      }
    });
  }

  getCustomers() {
    this.showGrid = false;
    this.service.getCustomersData().subscribe((response: any) => {
      this.customers = response.data.sort((a, b) => a.id - b.id);
      this.allCustomers = this.customers;
    })
  }
  getProjects(clientId: number) {

    this.projectInputValue.setValue('');
    this.managerInputValue.setValue('');
    this.clintId = clientId;
    this.showGrid = false;
    this.showSearchBox = false;
    this.projects = [];
    this.managers = [];

    this.service.getProjectsData(clientId).subscribe((response: any) => {
      this.allProjects = response.data;
      this.projects = this.allProjects;
    })
  }
  getManagers(projectId: number) {
    this.managerInputValue.setValue('');
    this.projectId = projectId;
    this.showGrid = false;
    this.showSearchBox = false;
    this.managers = [];
    this.managers = this.projects.find(i => i.id == projectId).managers;
    this.allManagers = this.managers;
  }
  onSelectManager(managerId: number) {
    this.managerId = managerId;
    this.showSearchBox = true;
  }
  onClick() {
    this.service.getProjectTechstack(this.clintId, this.projectId, this.managerId).subscribe((response: any) => {
      this.projectData = response.data;
      this.showGrid = true;
      this.serviceLinesMap = JSON.parse(JSON.stringify(this.intialServiceLinesMap));
    }, error => {
      this.showGrid = true;
      this.projectData = true;
      this.serviceLinesMap = JSON.parse(JSON.stringify(this.intialServiceLinesMap));
    }
    )
  }

  competencyAndServiceLineGridData() {
    this.service.getProjectCompetenciesData().subscribe((AllcompetenciesData: any) => {
      this.serviceLinesMap = AllcompetenciesData.data;
      this.intialServiceLinesMap = JSON.parse(JSON.stringify(this.serviceLinesMap));
    })
  }
  getFilteredCustomers(event: any) {
    if (event) {
      this.customers = Object.assign([], this.allCustomers).filter(
        item => item.name.toLowerCase().indexOf(event.toLowerCase()) > -1
      )
      this.showSearchBox = this.customers.length > 0;
    }
    else {
      this.customers = this.allCustomers;
      this.showSearchBox = false;
    }
  }
  getFilteredProject(event: any) {
    if (event) {
      this.projects = Object.assign([], this.allProjects).filter(
        item => item.name.toLowerCase().indexOf(event.toLowerCase()) > -1
      )
      this.showSearchBox = this.projects.length > 0;
    }
    else {
      this.projects = this.allProjects;
      this.showSearchBox = false;
    }
  }
  getFilteredManagers(event: any) {
    if (event) {
      this.managers = Object.assign([], this.allManagers).filter(
        item => item.name.toLowerCase().indexOf(event.toLowerCase()) > -1
      )
      this.showSearchBox = this.managers.length > 0;
    }
    else {
      this.managers = this.allManagers;
      this.showSearchBox = false;
    }
  }
}

